module.exports = __webpack_public_path__ + "dbadge-verified-200x68.png";